import { services } from '../app/services.js';
import { AsyncDataPipeable } from '../base/pipeable/async_data_pipeable.js';

class LocationDetails extends AsyncDataPipeable {
  set(data) {
    this.#location.set(data);
    this.#location.refreshReviews();
    super.set(this.#location);
  }

  toString() {
    return `LocationDetails`;
  }

  // implementation

  constructor(location) {
    super();
    this.#location = location;
  }

  getLoadPromise() {
    if (this.#location.id || this.#location.provider) {
      return services.location.getLocationInfo(this.#location.data);
    }
    return Promise.resolve(this.#location.data);
  }

  get dataClassName() {
    return 'location-details';
  }

  #location;
}

export { LocationDetails };
